export default __webpack_public_path__ + "static/media/dollar_coin.f61bc85a.png";